<div class="pallet-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">Pallet configuration </span>
    <button
      type="button"
      class="closeModal pull-right"
      (click)="savePallet(true)"
      aria-label="Close"
    >
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <div class="row">
      <form [formGroup]="palletAddEditForm">
        <div class="col-12 custom-margin">
          <label *ngIf="palletAddEditForm.get('palletType')?.value" class="sub-header-drpdown pb-2"
            >What type of pallet is it?</label
          >
          <ng-select
            [clearable]="true"
            [clearOnBackspace]="false"
            #palletType
            [items]="palletList.palletType"
            formControlName="palletType"
            (change)="selectedPallet($event)"
            [searchable]="false"
            bindLabel="name"
            placeholder="What type of pallet is it?"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  type="text"
                  class="form-control accordion-search search-input"
                  id="inputValidation"
                  placeholder="Search..."
                  (input)="palletType.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              (submitted || palletAddEditForm.controls['palletType']?.touched) &&
              palletAddEditForm.controls['palletType']?.invalid
            "
            class="input-error"
          >
            Pallet type is required.
          </div>
        </div>
        <div class="col-12 custom-margin">
          <label
            *ngIf="palletAddEditForm.get('palletReusable')?.value"
            class="sub-header-drpdown pb-2"
            >Is the pallet reusable?</label
          >
          <ng-select
            [clearable]="true"
            [clearOnBackspace]="false"
            #palletReuseable
            [items]="isPalletReusable"
            formControlName="palletReusable"
            (change)="isReusable($event)"
            [searchable]="false"
            bindLabel="name"
            placeholder="Is the pallet reusable?"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  type="text"
                  class="form-control accordion-search search-input"
                  id="inputValidation"
                  placeholder="Search..."
                  (input)="palletReuseable.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              (submitted || palletAddEditForm.controls['palletReusable']?.touched) &&
              palletAddEditForm.controls['palletReusable']?.invalid
            "
            class="input-error"
          >
            Please select whether the pallet is reusable.
          </div>
        </div>

        <div class="col-12 custom-margin">
          <label
            *ngIf="palletAddEditForm.get('totalPalletReuses')?.value"
            class="sub-header-drpdown pb-2"
            >How many reuses does the pallet have?</label
          >
          <ng-select
            [clearable]="true"
            [readonly]="disableNoOfReuses"
            [clearOnBackspace]="false"
            #palletReuses
            [items]="reuseList"
            formControlName="totalPalletReuses"
            (change)="totalReuses($event)"
            [searchable]="false"
            bindLabel="name"
            placeholder="How many reuses does the pallet have?"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  type="text"
                  class="form-control accordion-search search-input"
                  id="inputValidation"
                  placeholder="Search..."
                  (input)="palletReuses.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              (submitted || palletAddEditForm.controls['totalPalletReuses']?.touched) &&
              palletAddEditForm.controls['totalPalletReuses']?.invalid
            "
            class="input-error"
          >
            Number of reuses is required.
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light cancelBtn" (click)="savePallet(true)">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="savePallet()">Save</button>
  </div>
</div>
